import React, { useCallback, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { Navigate, useParams } from "react-router-dom";
import { getWaitlistClaimApi } from "../../api/api";
import { ResultShell } from "../cumpleanos/BirthdaySteps";
import { claimDestination } from "./waitlistModel";
import "../reservas/reservas.css";
import "../cumpleanos/cumpleanos.css";

const Shell = ({ children }) => <div className="reservas-root bday">{children}</div>;

/** Message when the slot is gone: depends on how the entry ended. */
const unavailableCopy = (status) => {
  if (status === "booked") return { icon: "check", title: "Ya reservaste este lugar", text: "" };
  if (status === "expired") return { icon: "clock", title: "La anotación venció", text: "" };
  return {
    icon: "info",
    title: "Alguien ya tomó ese horario",
    text: "Seguís anotado/a por si se libera otro.",
  };
};

/**
 * Landing of the availability notice (/lista-de-espera/reservar/:token). Works without login: if the slot is
 * still free it sends the buyer to the venue's public booking page with the day and the request preloaded.
 */
const WaitlistClaim = () => {
  const { token } = useParams();
  // status: loading | invalid | error | redirect | unavailable
  const [state, setState] = useState({ status: "loading", claim: null, target: null });
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    let active = true;
    getWaitlistClaimApi(token)
      .then((res) => {
        if (!active) return;
        const claim = res?.data?.info;
        if (!claim?.entry) return setState({ status: "invalid", claim: null, target: null });
        const entryStatus = claim.entry.status;
        const open = claim.available === true && (!entryStatus || entryStatus === "active");
        const target = open ? claimDestination(claim, token) : null;
        setState({ status: target ? "redirect" : "unavailable", claim, target });
      })
      .catch((err) => {
        if (!active) return;
        // A bad, expired or unknown token look the same on purpose.
        setState({ status: err?.response?.status === 404 ? "invalid" : "error", claim: null, target: null });
      });
    return () => {
      active = false;
    };
  }, [token, reloadKey]);

  const reload = useCallback(() => {
    setState({ status: "loading", claim: null, target: null });
    setReloadKey((k) => k + 1);
  }, []);

  if (state.status === "redirect") {
    return <Navigate to={state.target.to} state={state.target.state} replace />;
  }
  if (state.status === "loading") {
    return (
      <Shell>
        <div className="bday-state">
          <Spinner animation="border" />
        </div>
      </Shell>
    );
  }
  if (state.status === "invalid") {
    return (
      <Shell>
        <ResultShell icon="search" tone="neutral" title="Link inválido o vencido">
          <p>Revisá que lo hayas copiado completo desde el mensaje.</p>
        </ResultShell>
      </Shell>
    );
  }
  if (state.status === "error") {
    return (
      <Shell>
        <ResultShell icon="alert" tone="danger" title="No pudimos cargar el aviso">
          <p>Probá de nuevo en unos segundos.</p>
          <div className="bday-state-actions">
            <button type="button" className="r-btn-primary" onClick={reload}>Reintentar</button>
          </div>
        </ResultShell>
      </Shell>
    );
  }

  const copy = unavailableCopy(state.claim?.entry?.status);
  return (
    <Shell>
      <ResultShell icon={copy.icon} tone="neutral" title={copy.title}>
        {copy.text && <p>{copy.text}</p>}
      </ResultShell>
    </Shell>
  );
};

export default WaitlistClaim;
